import { getFilterComponent } from './@arch/getFilterComponent';
import React from 'react';
export const FilterDisplay = ({ componentMapper = getFilterComponent, displayAsTag, filter, filterParams, sonarObjectId, sonarObjectType, updateFilterParams }) => {
    var _a;
    const { filterComponent, filterFormat, filterId, filterLabel, filterMetadata } = filter;
    const FilterDisplayComponent = filterComponent !== null && filterComponent !== void 0 ? filterComponent : componentMapper(filter);
    if (!FilterDisplayComponent) {
        return null;
    }
    return (React.createElement(FilterDisplayComponent, { displayAsTag: displayAsTag, format: filterFormat, id: filterId, key: filterId, label: filterLabel, metadata: filterMetadata, onChange: updateFilterParams, params: filterParams, sonarObjectId: sonarObjectId, sonarObjectType: sonarObjectType, value: (_a = filterParams[filterId]) === null || _a === void 0 ? void 0 : _a.value }));
};
